import { type Static, Type } from '@sinclair/typebox';
import { PaginateDTOSchema } from '../dto/common.dto.js';
import { PodcastEpisodeDTOSchema } from '../dto/podcast-episode.dto.js';
import { UserDTOSchema, UserSettingsDTO } from '../dto/user.dto.js';

export const PSEUDO_VALIDATION_REGEX = /^[a-z0-9_]{3,20}$/;
const PseudoSchema = Type.String({ pattern: PSEUDO_VALIDATION_REGEX.source });

// =====================================================================================================================
// Subscribe To
// =====================================================================================================================

export const SubscribeToBodySchema = Type.Object({ channelId: Type.String() });
export type SubscribeToBody = Static<typeof SubscribeToBodySchema>;

// =====================================================================================================================
// Check Pseudo Availability
// =====================================================================================================================

export const CheckPseudoAvailabilityBodySchema = Type.Object({ pseudo: PseudoSchema });
export type CheckPseudoAvailabilityBody = Static<typeof CheckPseudoAvailabilityBodySchema>;

export const CheckPseudoAvailabilityReplySchema = Type.Object({ isAvailable: Type.Boolean() });
export type CheckPseudoAvailabilityReply = Static<typeof CheckPseudoAvailabilityReplySchema>;

// =====================================================================================================================
// Register
// =====================================================================================================================

export const RegisterBodySchema = Type.Object({
  email: Type.String({ format: 'email' }),
  uid: Type.String(),
  invitationCode: Type.Optional(Type.String()),
});
export type RegisterBody = Static<typeof RegisterBodySchema>;

export const RegisterReplySchema = Type.Intersect([
  Type.Omit(UserDTOSchema, ['pseudo']),
  Type.Object({
    pseudo: Type.Optional(UserDTOSchema.properties.pseudo),
  }),
]);
export type RegisterReply = Static<typeof RegisterReplySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const UnsubscribeFromBodySchema = Type.Object({ channelId: Type.String() });
export type UnsubscribeFromBody = Static<typeof UnsubscribeFromBodySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const UpdatePseudoBodySchema = Type.Object({ pseudo: PseudoSchema });
export type UpdatePseudoBody = Static<typeof UpdatePseudoBodySchema>;

// ---------------------------------------------------------------------------------------------------------------------

export const UpdateSettingsBodySchema = UserSettingsDTO;
export type UpdateSettingsBody = Static<typeof UpdateSettingsBodySchema>;

// =====================================================================================================================
// Delete account
// =====================================================================================================================

export const DeleteAccountBodySchema = Type.Object({ cancel: Type.Optional(Type.Boolean()) });
export type DeleteAccountBody = Static<typeof DeleteAccountBodySchema>;

// =====================================================================================================================
// Library list already started episodes
// =====================================================================================================================

export const ListLibraryAlreadyStartedEpisodesReplySchema = Type.Array(PodcastEpisodeDTOSchema);
export type ListLibraryAlreadyStartedEpisodesReply = Static<typeof ListLibraryAlreadyStartedEpisodesReplySchema>;

// =====================================================================================================================
// Library list non started episodes
// =====================================================================================================================

export const ListLibraryNonStartedEpisodesQuerySchema = Type.Object({ page: Type.Number() });
export type ListLibraryNonStartedEpisodesQuery = Static<typeof ListLibraryNonStartedEpisodesQuerySchema>;

export const ListLibraryNonStartedEpisodesReplySchema = PaginateDTOSchema(PodcastEpisodeDTOSchema);
export type ListLibraryNonStartedEpisodesReply = Static<typeof ListLibraryNonStartedEpisodesReplySchema>;
